import { smcmModuleMap, zoneMap, questionTypeMap } from '@/constant'
export const todaMap = value => {
  let name = ''
  switch (value) {
    case 'MODULE_1':
      name = 'KIK'
      break
    case 'MODULE_2':
      name = 'PS'
      break
    case 'MODULE_3':
      name = 'EB'
      break
    case 'MODULE_8':
    case 'MODULE_7':
      name = 'CS'
      break
    case 'INTERVIEW':
      name = ''
      break
    case 'MODULE_20':
      name = ''
      break
  }
  return name
}
// Module映射
export const appModuleTitleMap = value => {
  if (!value) return ''
  return smcmModuleMap.filter(item => item.value === value)[0]['title']
}
// zone映射
export const zoneTitleMap = value => {
  if (!value) return ''
  return zoneMap.filter(item => item.value === value)[0]['title']
}
// 代办事项 - title
export const todoStatusTitleMap = status => {
  let title = ''
  switch (status) {
    case 'TO_BE_COMPLETE_MENTOR':
      title = '待导师确认时间，请留意'
      break
    case 'TO_BE_COMPLETE_MENTEE':
      title = '导师重新给出了预约时间，请确认'
      break
    case 'INCOMPLETE':
      title = '辅导时间已经确认，请准时参加'
      break
    case 'COMPLETE':
      title = '请查看Feedback并评价导师'
      break
    case 'SYSTEM_RECALL':
      title = '系统自动撤回'
      break
    case 'RECALL':
      title = 'CD已撤回预约'
      break
    case 'TO_FEEDBACK':
      title = '待导师填写Feedback，请留意 待反馈'
      break
    case 'HAS_EVALUATE':
      title = '已完成'
      break
  }
  return title
}
// 代办事项 - color
export const todoStatusColorMap = status => {
  let color = ''
  switch (status) {
    case 'COMPLETE':
    case 'TO_BE_COMPLETE_MENTEE':
      color = 'orange'
      break
    case 'TO_BE_COMPLETE_MENTOR':
    case 'INCOMPLETE':
    case 'TO_FEEDBACK':
      color = 'green'
      break
    case 'SYSTEM_RECALL':
    case 'RECALL':
    case 'HAS_EVALUATE':
      color = 'gray'
      break
  }
  return color
}
// 中文数字
export const chineseNum = num => {
  let chNum = ''
  switch (num) {
    case 1:
      chNum = '一'
      break
    case 2:
      chNum = '二'
      break
    case 3:
      chNum = '三'
      break
  }
  return chNum
}
// 问题反馈title
export const questionTypeTitleMap = type => {
  if (!type) return ''
  return questionTypeMap.filter(item => item.value === type)[0]['title']
}
// 填充 0
export const fillZero = num => {
  return num < 10 ? `0${num}` : num
}
